import React, { useState } from "react";
import RouteLink from "./RouteLink";
import ChildDropDown from "./ChildDropDown";
import { Link } from "react-router-dom";

const MobileNav = ({ childrenList, mobileMenuToggle }) => {
    const [toggle, settoggle] = useState(false);

    return (
        <div className={mobileMenuToggle ? "mobile-nav active" : "mobile-nav"}>
            <div className="mobile-nav-container">
                <ul>
                    <li className="site-brand">World Vision</li>
                </ul>

                <hr />

                <ul>
                    <li>
                        <Link
                            id="link-my-profile"
                            to="/user/profile"
                            title="My Profile"
                        >
                            <i className="fas fa-user-circle" /> My Profile
                        </Link>
                    </li>
                    <li>
                        <Link to="/logout">
                            <i className="fas fa-sign-out-alt" /> Log out
                        </Link>
                    </li>
                </ul>

                <hr />

                <ul>
                    <li>
                        <RouteLink path="/dashboard">
                            <i className="fas fa-home" /> Home
                        </RouteLink>
                    </li>
                    <li>
                        <a
                            href="#child"
                            onClick={e => {
                                e.preventDefault();
                                settoggle(!toggle);
                            }}
                        >
                            <span className="menu-text">
                                <i className="fas fa-child" /> Child{" "}
                                <i className="far fa-caret-square-down" />
                            </span>
                        </a>
                        <ChildDropDown
                            childrenList={childrenList}
                            toggle={toggle}
                        />
                    </li>
                    <li>
                        <RouteLink path="/dashboard/my-updates">
                            <i className="fas fa-pen" /> My Updates
                        </RouteLink>
                    </li>
                    <li>
                        <RouteLink path="/dashboard/my-donation">
                            <i className="fas fa-donate" /> My Donation
                        </RouteLink>
                    </li>
                    <li>
                        <RouteLink path="/dashboard/letters">
                            <i className="fas fa-envelope" /> Letters
                        </RouteLink>
                    </li>
                    {/* <li>
                        <RouteLink path="/dashboard/visit-my-child">
                            <i className="fas fa-bus" /> Visit my Child
                        </RouteLink>
                    </li> */}
                    <li>
                        <RouteLink path="/dashboard/faq">
                            <i className="fas fa-question-circle" /> FAQs
                        </RouteLink>
                    </li>
                    <li>
                        <RouteLink path="/dashboard/contact-us">
                            <i className="fas fa-phone-square" /> Contact Us
                        </RouteLink>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default MobileNav;
